const explicitBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

function getDefaultBaseUrl() {
  if (typeof window === 'undefined') {
    return '';
  }

  if (window.location.hostname === 'localhost') {
    return 'http://localhost:4000';
  }

  return '';
}

export const API_BASE_URL = explicitBaseUrl || getDefaultBaseUrl();
